const pickAttributes = (obj, ...keys) => {
  const newObj = {};
  for (const key of keys) {
    // Check if the key exists on the source object before adding it
    if (key in obj) {
      newObj[key] = obj[key];
    }
  }
  return newObj;
}

export {
  pickAttributes
};


// WEBPACK FOOTER //
// ./src/helpers/object_helpers.js